import { fetchWrapper } from '../../utils/request';
import { SAVE_DELIVERY_ORDER } from '@/store/api-points';

const state = {
    orders: [],
    pagesCount: 0,
    statusChoice: {}
};

const getters = {
    deliveryOrders: state => {
        return state.orders;
    }
};

const actions = {
    fetchOrders(context, searchParams) {
        return fetchWrapper('/delivery_order/orders/', { searchParams })
            .then(({ data }) => {
                context.commit('setOrders', data);
                return data;
            });
    },

    saveOrder(context, { id, order }) {
        return fetchWrapper(SAVE_DELIVERY_ORDER.replace(':id', id), {
            method: 'POST',
            body: {
                order
            }
        });
    },

    sendDeliveryOrders(context, { selectedItemsIdList }) {
        return fetchWrapper('/delivery_order/orders/send/', {
            method: 'POST',
            body: {
                order_ids: selectedItemsIdList
            }
        });
    },
    deleteDeliveryOrders(context, { selectedItemsIdList }) {
        return fetchWrapper('/delivery_order/orders/delete/', {
            method: 'POST',
            body: {
                order_ids: selectedItemsIdList
            }
        });
    }
};

const mutations = {
    setOrders(state, { items: orders, pages_count: pagesCount, status_choice: statusChoice }) {
        state.orders = orders;
        state.pagesCount = pagesCount;
        state.statusChoice = statusChoice;
    },
    updateOrdersStatuses(state, statusesByOrders) {
        for (const order of state.orders) {
            if (statusesByOrders[order.id]) {
                order.status = statusesByOrders[order.id];
            }
        }
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/ordersTransfer.js